import React, { useRef, useState } from "react";
import { ReactComponent as DemoBackgroundIcon } from '../../assets/icons/demonstration-background.svg';
import DemoPage from "./demo_page/demo-page";
import EchoButton from "../../items/echo-button/echo-button";
import s from "./demonstration-product.module.scss"

const DemonstrationProduct = (props) => {

    const [active, setActive] = useState(props.demoMenu[0].name);

    const myRef = useRef(null);

    const showDemoModal = (isShow) => {
        props.setShowDemo()
    }

    const handlerScroll = (elId) => {
        
        const el = document.getElementById(elId);
        el.scrollIntoView({ alignToTop: false, block: 'end', inline: "start", behavior: "smooth" });
        setActive(elId);
    }

    const buttons = props.demoMenu.map((k,i) => 
        <button key={i} onClick={handlerScroll.bind(this, k.name)} className={active ===k.name ? s.menuButton+" "+s.activeButton : s.menuButton}>
            <span>{ props.getValue(k.name) }</span>
        </button>
    );

    const page = props.demoContent.map((k, i) => 
        <DemoPage key={i} getValue={props.getValue} content={k}/>
    )


    return (
        <div className={s.DemonstrationProduct}>
<div className={s.demoBackground}><DemoBackgroundIcon /></div>

            <h1>{props.getValue('DEMONSTRATION_PRODUCT')}</h1>
            <div className={s.demoMenu}>
                { buttons }
            </div>
            <div className={s.demoContent}>
                
                { page }
            </div>
            <div className={s.mainButtonsBlock}>
                <EchoButton title={props.getValue('GET_DEMO_ACCESS')} callback={showDemoModal}/>
            </div>
            
        </div>
    )
}

export default DemonstrationProduct;